"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfMaterialColorSpecDualListItem = instanceOfMaterialColorSpecDualListItem;
exports.MaterialColorSpecDualListItemFromJSON = MaterialColorSpecDualListItemFromJSON;
exports.MaterialColorSpecDualListItemFromJSONTyped = MaterialColorSpecDualListItemFromJSONTyped;
exports.MaterialColorSpecDualListItemToJSON = MaterialColorSpecDualListItemToJSON;
exports.MaterialColorSpecDualListItemToJSONTyped = MaterialColorSpecDualListItemToJSONTyped;
/**
 * Check if a given object implements the MaterialColorSpecDualListItem interface.
 */
function instanceOfMaterialColorSpecDualListItem(value) {
    return true;
}
function MaterialColorSpecDualListItemFromJSON(json) {
    return MaterialColorSpecDualListItemFromJSONTyped(json, false);
}
function MaterialColorSpecDualListItemFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'order': json['order'] == null ? undefined : json['order'],
    };
}
function MaterialColorSpecDualListItemToJSON(json) {
    return MaterialColorSpecDualListItemToJSONTyped(json, false);
}
function MaterialColorSpecDualListItemToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
        'order': value['order'],
    };
}
